module.exports = __webpack_public_path__ + "static/media/手和ipad.3590902c.jpg";